<template>
  <div>
    <Header />
    <div class="container">
      <div class="row">
        <div class="col-sm-12 text-left">
          <a v-on:click.prevent="backToHome()">
            <img class="volver" src="@/assets/img/volver.png">
            Volver a búsqueda
          </a>
        </div>
      </div>
    </div>
    <div class="container">
      <div class="row">
        <div class="col-sm-1">
          <img class="evaluacion_finger" src="@/assets/img/explorador-de-grabaciones-copy-evaluacion@3x.png" />
        </div>
        <div class="col-sm-11">
          <div class="text_incio">Escucha y Evaluación</div>
        </div>
      </div>
      <div class="row">
        <div class="col-sm-12">
          <img class="line" src="@/assets/img/line.png" />
        </div>
        <div class="col-sm-12">
          <div class="text-center Nombre-grabacin-01">Interaction ID: {{ recordingData.id_interaction }}</div>
          <audio controls v-if="file" id ="audio-player" class="audioPlayer">
            <source v-bind:src="file">
            Your browser does not support the audio element.
          </audio>
          <div>
            <b-button block variant="primary" v-on:click.prevent="onClick">Descargar Grabación</b-button>
          </div>
        </div>
        <div class="col-sm-12">
          <div class="txt_selec">Seleccione formulario y agente a evaluar:</div>
        </div>
      </div>
      <div class="row">
        <div class="col-sm-6">
          <b-form-select v-model="selected" :options="options" @change="selectForm"></b-form-select>
        </div>
        <div class="col-sm-6">
          <b-form-select v-model="selectedAgent" :options="optionsAgent"></b-form-select>
        </div>
      </div>

      <div class="row" v-if="selected">
        <div class="col-sm-12">
          <div class="txt_form_name"> {{ selected }} </div>
        </div>
        <div class="col-sm-12">
          <div class="txt_agent_name"> {{ selectedAgent }} </div>
        </div>
        <div class="col-sm-12">
          <img class="line" src="@/assets/img/line.png" />
        </div>
        <div class="col-sm-12 text-right text-valores">
          {{ fromText }}
        </div>
      </div>

      <!-- FORMULARIOS -->

      <!-- FORMULARIO 1 -->
      <SenatiCalidadVenta v-if="form1Show" :evaluador="evaluadroEmail" @getFlushData="getFlushData" />
  
      <!-- FORMULARIO 2 -->
      <SenatiCalidadSenatiATC v-if="form2Show" :evaluador="evaluadroEmail" @getFlushData="getFlushData" />

      <!-- FORMULARAIO 3 -->
      <SenatiFormulariodeEvaluacionSCC v-if="form3Show" :evaluador="evaluadroEmail" @getFlushData="getFlushData" />

      <!-- FOMULARIO INLEARNING 1 -->
      <InLearningFormularioVentas v-if="formInLearning1Show" :evaluador="evaluadroEmail" @getFlushData="getFlushData" />
      <!-- FOMULARIO INLEARNING 1 -->
      <InLearningFormularioATC v-if="formInLearning2Show" :evaluador="evaluadroEmail" @getFlushData="getFlushData" />

      <FlashMessage position="right top"></FlashMessage>
    </div>

  </div>
</template>

<script>
  import Header from '@/components/HeaderComponent.vue'
  import SenatiCalidadVenta from '@/components/senati/SenatiCalidadVenta.vue'
  import SenatiCalidadSenatiATC from '@/components/senati/SenatiCalidadSenatiATC.vue'
  import SenatiFormulariodeEvaluacionSCC from '@/components/senati/SenatiFormulariodeEvaluacionSCC.vue'

  import InLearningFormularioATC from '@/components/inlearning/InLearningFormularioATC.vue'
  import InLearningFormularioVentas from '@/components/inlearning/InLearningFormularioVentas.vue'


  export default {
    components: {
      Header,
      SenatiCalidadVenta,
      SenatiCalidadSenatiATC,
      SenatiFormulariodeEvaluacionSCC,
      InLearningFormularioVentas,
      InLearningFormularioATC
    },
    data() {
      return {
        show: true,
        recordingData: null,
        file: null,
        selected: null,
        form1Show: false,
        form2Show: false,
        form3Show: false,
        formInLearning1Show: false,
        formInLearning2Show: false,
        selectedAgent: null,
        fromText: null,
        formSave: null,
        evaluadroEmail: null,
        organization_id: null,
        options: [],
        optionsAgent: [{
          value: null,
          text: 'Agente a evaluar'
        }],
      }
    },
    created() {
      console.log(this.$route);
      console.log(this.$route.params.recording_id);
      console.log('route', this.$route.params.recording_id);
      //this.getAudio(this.$route.params.recording_id);
      this.getAudio(this.$route.params.recording_id);
      
      this.getUserMe();
    },
    methods: {
      selectForm(val) { // Just a regular js function that takes 2 args
        console.log(val);
        if (val === "Calidad Ventas") {
          this.form1Show = true;
          this.form2Show = false;
          this.form3Show = false;
          this.formSave = val;
          this.fromText = "Máximo total de puntos 35 | Peso: 1 | Ponderación total del máximo de puntos: 35";
        } else if (val === "Calidad Senati ATC") {
          this.form1Show = false;
          this.form2Show = true;
          this.form3Show = false;
          this.formSave = val;
          this.fromText = "Máximo total de puntos 35 | Peso: 1 | Ponderación total del máximo de puntos: 35";
        } else if (val === "Formulario de Evaluación SCC") {
          this.form1Show = false;
          this.form2Show = false;
          this.form3Show = true;
          this.formSave = val;
          this.fromText = "Máximo total de puntos 15 | Peso: 1 | Ponderación total del máximo de puntos: 15";
        } else if (val === "InLearning - Formulario Ventas") {
          this.formInLearning1Show = true;
          this.formInLearning2Show = false;
          this.formSave = val;
          this.fromText = "";
        } else if (val === "InLearning - Formulario ATC") {
          this.formInLearning1Show = false;
          this.formInLearning2Show = true;
          this.formSave = val;
          this.fromText = "";
        } else {
          this.form1Show = false;
          this.form2Show = false;
          this.form3Show = false;
          this.formInLearning1Show = false;
          this.formInLearning2Show = false;
          this.fromText = null;
          this.formSave = null;
        }

      },
      getAudio(recording_id) {
        console.log(recording_id);
        return this.axios.get(`api/recordings/audio/${btoa(recording_id)}`)
          .then(response => {
            if (response.status === 200 && response.data) {
              console.log(response.data);
              this.recordingData = response.data;
              this.file = response.data.audio_file;
              this.getAudioFtpURL( response.data.audio_file , response.data.id_interaction);
             
             // this.file = "https://five9-recording-movigoo-v2.s3-eu-west-1.amazonaws.com/SENATI/2_1_2021/%2B51052606938-contactcenter35%40scc.com.pe-901271-2_1_2021-7_58_37+PM--235D168B3573452D8C1EA945D51011F1-10680.wav";
             
             
             this.optionsAgent = [{
                value: response.data.agent_account,
                text: response.data.agent_account
              }];
              this.selectedAgent = response.data.agent_account;
              // return response.data;
            }
          }).catch(errors => {
            console.log(errors);
            return null;
          });
      },

  getAudioFtpURL(file,id){
    
  
     //AXios llamar a web service AQUI VA EL ENDPOINT DEFINITVO PARA EXTRAER EL FTP
     return this.axios.post("https://transcoding.movigooapp.com/api/FtpPathToURl",{
        "linkRecording":file,
        "idCall":id,
        "urlToReturn":"https://transcoding.movigooapp.com/storage/"

     }).then(response => {
      //console.log(response.data.url);
      var audio = document.getElementById("audio-player");
      this.file = response.data.url;
      console.log(this.file);
      audio.src = response.data.url;
      audio.play();
      


     });

   },
      onClick() {
        console.log("HOLASS");
        console.log(this.file);
        window.open(this.file, "_blank");
      },
      getUserMe() {
        this.axios
          .get("/api/me")
          .then((result) => {
            console.log(result);
            this.evaluadroEmail = result.data.email;
            this.organization_id = result.data.organization_id;
            if (this.organization_id === 2) {
              this.options = [{
                  value: null,
                  text: 'Formulario'
                },
                {
                  value: 'Calidad Ventas',
                  text: 'Calidad Ventas'
                },
                {
                  value: 'Calidad Senati ATC',
                  text: 'Calidad Senati ATC'
                },
                {
                  value: 'Formulario de Evaluación SCC',
                  text: 'Formulario de Evaluación SCC'
                }
              ]
            }else if (this.organization_id === 3) {
              this.options = [{
                  value: null,
                  text: 'Formulario'
                },
                {
                  value: 'InLearning - Formulario ATC',
                  text: 'InLearning - Formulario ATC'
                },
                {
                  value: 'InLearning - Formulario Ventas',
                  text: 'InLearning - Formulario Ventas'
                }
              ]
            }

          }).catch(error => {
            console.log(error.response.status)
            if (error.response.status === 403) {
              this.$store.dispatch('auth/logout');
              this.$router.push('/login');
            }
          });
      },
      backToHome() {
        this.$router.push({
          name: 'Home'
        });
      },
      getFlushData(item) {
        this.flashMessage.info(item);
      }
    },
  }
</script>

<style>
  .textarea_margin {
    margin-top: 2%;
  }

  .volver {
    width: 11px;
    height: 18px;
    margin: 0 12px 4px 0;
    object-fit: contain;
  }

  .evaluacion_finger {
    width: 41px;
    margin: 52px 9px 0 0;
    object-fit: contain;
  }

  .Rectangle-Copy {
    width: 198px;
    height: 40px;
    margin: 44px 15px 0 42px;
    background-color: #39b54a;
  }

  .Rectangle-Copy:hover {
    width: 198px;
    height: 40px;
    margin: 44px 15px 0 42px;
    background-color: #39b54a;
  }

  .Rectangle-Copy-19 {
    width: 198px;
    height: 40px;
    margin: 44px 159px 0 15px;
    background-color: #ff3232;
  }

  .Rectangle-Copy-19:hover {
    width: 198px;
    height: 40px;
    margin: 44px 159px 0 15px;
    background-color: #ff3232;
  }

  .line {
    width: 100%;
    height: 1px;
    margin: 7px 0 28px;
    border: solid 1px #979797;
  }

  .text_incio {
    width: 179px;
    height: 21px;
    margin: 68px 0px 0px -39px;
    font-family: TrebuchetMS;
    font-size: 18px;
    font-weight: bold;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    text-align: center;
    color: var(--black);
  }

  .audioPlayer {
    width: 100%;
  }

  .txt_selec {
    width: 246px;
    height: 15px;
    margin: 20px 0 20px 0;
    font-family: TrebuchetMS;
    font-size: 14px;
    font-weight: normal;
    font-stretch: normal;
    font-style: italic;
    line-height: normal;
    letter-spacing: normal;
    color: var(--black);
  }

  .txt_form_name {
    width: 409px;
    height: 21px;
    margin: 40px 0 0 0;
    font-family: TrebuchetMS;
    font-size: 20px;
    font-weight: bold;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    color: var(--black);
  }

  .txt_agent_name {
    width: 200px;
    height: 15px;
    margin: 12px 0 5px 0;
    font-family: TrebuchetMS;
    font-size: 13px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    color: var(--black);
  }

  .text-valores {
    font-family: TrebuchetMS;
    font-size: 13px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    color: var(--black);
  }

  .puntos {
    width: 55px;
    height: 15px;
    font-family: TrebuchetMS;
    font-size: 13px;
    font-weight: normal;
    font-stretch: normal;
    font-style: italic;
    line-height: normal;
    letter-spacing: normal;
    color: var(--black);
  }

  .Nombre-grabacin-01 {
    height: 21px;
    margin: 0 35px 22px 1.6px;
    font-family: TrebuchetMS;
    font-size: 18px;
    font-weight: bold;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    text-align: center;
    color: var(--black);
  }
</style>